import clsx from "clsx";
import { ReactNode } from "react";

type CardProps = {
  className?: string;
  children: ReactNode;
};

export default function Card({ className = "", children }: CardProps) {
  return (
    <div
      className={clsx(
        "block bg-black/70 backdrop-blur-xl border border-white/15 rounded-lg p-6 transition-all duration-300 hover:bg-white/10 hover:border-white/25 hover:shadow-lg hover:shadow-white/10 space-y-4",
        className
      )}
    >
      {children}
    </div>
  );
}

export { Card };
